
import { negate } from '../function/negate';
import { isArray } from './isArray';
import { isBoolean } from './isBoolean';
import { isDevEnv } from './isDev';
import { isEmail } from './isEmail';
import { isEmptyArray } from './isEmptyArray';
import { isExisty } from './isExisty';
import { isFalse } from './isFalse';
import { isFalsy } from './isFalsy';
import { isFunction } from './isFunction';
import { isJson } from './isJson';
import { isNull } from './isNull';
import { isNumber } from './isNumber';
import { isObject } from './isObject';
import { isObjectLike } from './isObjectLike';
import { isPlainObject } from './isPlainObject';
import { isString } from './isString';
import { isTrue } from './isTrue';
import { isTruthy } from './isTruthy';
import { isUndefined } from './isUndefined';

const is = {
  array: isArray,
  boolean: isBoolean,
  dev: isDevEnv,
  email: isEmail,
  emptyArray: isEmptyArray,
  existy: isExisty,
  false: isFalse,
  falsy: isFalsy,
  function: isFunction,
  json: isJson,
  null: isNull,
  number: isNumber,
  object: isObject,
  objectLike: isObjectLike,
  plainObject: isPlainObject,
  string: isString,
  true: isTrue,
  truthy: isTruthy,
  undefined: isUndefined
};

const notInterface = {};

Object.keys(is).forEach(key => notInterface[key] = negate(is[key]));

is.not = notInterface;

export default is;
